import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/sharp-solid-svg-icons';
import { useState } from 'react';
import './styles.css';

export interface SCPanelProps {
  Label: string;
  children: React.ReactNode;
  Hideable?: boolean;
  InitialHide?: boolean;
}

export function SCPanel(props: SCPanelProps) {
  const [show, setShow] = useState(props.InitialHide == null ? true : !props.InitialHide);

  return (
    <div className="sc-eone-ui-panel-container">
      <div className="sc-eone-ui-panel-header">
        {props.Hideable == true ? (
          <button className="sc-eone-ui-panel-title" onClick={() => setShow(!show)}>
            <span className="eone-ui-panel-heading">{props.Label}</span>

            <span className="sc-eone-ui-panel-chevron">
              {show ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <FontAwesomeIcon icon={faChevronDown} />
              )}
            </span>
          </button>
        ) : (
          <p className="sc-eone-ui-panel-title">{props.Label}</p>
        )}
      </div>
      {!props.Hideable && <div className="sc-eone-ui-panel-inner-container">{props.children}</div>}
      {show && props.Hideable && (
        <div className="sc-eone-ui-panel-inner-container">{props.children}</div>
      )}
    </div>
  );
}
